import { FC } from "react";
import { WHEEL_RAFFLE_STATUS_LABELS } from "../model/constants";
import type { WheelRaffleItemStatus } from "../model/types";

import styles from "./WheelRaffleStatusBadge.module.css";

interface Props {
  status: WheelRaffleItemStatus;
}

export const WheelRaffleStatusBadge: FC<Props> = ({ status }) => (
  <span className={`${styles.badge} ${styles[status]}`}>
    {WHEEL_RAFFLE_STATUS_LABELS[status]}
  </span>
);
